import { render, staticRenderFns } from "./CardTargetAudience.vue?vue&type=template&id=38537f9a&scoped=true&"
import script from "./CardTargetAudience.vue?vue&type=script&lang=js&"
export * from "./CardTargetAudience.vue?vue&type=script&lang=js&"
import style0 from "./CardTargetAudience.vue?vue&type=style&index=0&id=38537f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38537f9a",
  null
  
)

export default component.exports